import { render, staticRenderFns } from "./block1.vue?vue&type=template&id=15ae10b3&scoped=true&"
import script from "./block1.vue?vue&type=script&lang=js&"
export * from "./block1.vue?vue&type=script&lang=js&"
import style0 from "./block1.vue?vue&type=style&index=0&id=15ae10b3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae10b3",
  null
  
)

export default component.exports